import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'search-box',
    templateUrl: './search-box.component.html',
    styleUrls: ['./search-box.component.scss'],
    standalone: false
})
export class SearchBoxComponent implements OnInit {
  @Output() searchChanges = new EventEmitter<string>();
  @Input() placeholder = 'Search...';

  searchCtrl = new UntypedFormControl(null);

  ngOnInit() {
    this.searchCtrl.valueChanges
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((val) => this.searchChanges.emit(val));
  }

  onKeydown(event: KeyboardEvent) {
    if (event.code === 'Escape') {
      this.clear();
      event.stopPropagation();
    }
  }

  clear() {
    this.searchCtrl.setValue('');
  }
}
